/* eslint-disable */
import * as R from 'ramda';


const retrieveProgramTasks = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};


export default {
  retrieveProgramTasks
};
